<template>
	<Popper
		v-click-outside="closePopover"
		:isVisible="popoverVisible"
		placement="bottom-end"
		@keyup.escape="closePopover"
	>
		<BaseTooltip :text="tooltipText" :enabled="!popoverVisible" placement="bottom">
			<button
				:class="{'bg-gray-650': popoverVisible}"
				data-test="delete-session-button"
				class="button-icon"
				@click="popoverVisible = !popoverVisible"
			>
				<BaseIcon name="mono/trash" />
			</button>
		</BaseTooltip>
		<template #popup>
			<BasePopover data-test="delete-session-confirmation">
				<p class="px-12 py-4 text-gray-300">Delete this recording?</p>
				<template #footer>
					<div class="flex justify-end mx-4 mt-4">
						<button data-test="cancel-button" class="mr-16 link-gray" @click="closePopover">Cancel</button>
						<button data-test="confirm-button" class="button-red text-strong-base" @click="confirmDelete">
							Delete
						</button>
					</div>
				</template>
			</BasePopover>
		</template>
	</Popper>
</template>

<script>
import Popper from 'shared/components/Popper.vue'

export default {
	name: 'ButtonDelete',
	components: {
		Popper,
	},
	props: {
		tooltipText: {
			type: String,
			default: 'Delete recording',
		},
	},
	emits: ['delete'],
	data() {
		return {
			popoverVisible: false,
		}
	},
	methods: {
		confirmDelete() {
			this.$emit('delete')
			this.closePopover()
		},
		closePopover() {
			this.popoverVisible = false
		},
	},
}
</script>
